module.exports = __webpack_public_path__ + "d.no2.4bd86371.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/d.no2.jpg
// module id = KO4u
// module chunks = 0